import React from "react";

export default function Select({
  elem,
  typeVisited,
  data,
  setTypeVisited,
  setData,
  manualDocumentInfo,
  messageError,
}) {
  return (
    <div className="mb-2">
      <label for="nombre">
        {elem.label} <span className="obligatory"> *</span>
      </label>
      <select
        className={`${
          typeVisited ? (data?.entryType ? "" : "formError") : ""
        } selector form-select form-select-sm especialGroup shadow-sm formHover selectHeight`}
        name={elem.id}
        id={elem.id}
        onClick={() => setTypeVisited(true)}
        onChange={(e) => {
          setData({
            ...data,
            entryType: e.target.value,
          });
        }}
      >
        {elem.options.map((elem, index) => {
          if (index < 1) {
            return (
              <option
                className="hiddenSelected"
                disabled
                selected
                hidden
                key={index}
                value={elem?.values}
              >
                {elem?.option}
              </option>
            );
          }
          return (
            <option
              key={index}
              value={elem?.values}
              selected={
                manualDocumentInfo?.selected &&
                !manualDocumentInfo?.selected[0]?.document?.meta?.repeating &&
                elem?.option === "Entrada única"
                  ? true
                  : manualDocumentInfo?.selected &&
                    manualDocumentInfo?.selected[0]?.document?.meta
                      ?.repeating &&
                    elem?.option === "Entrada recurrente"
                  ? true
                  : false
              }
            >
              {elem?.option}
            </option>
          );
        })}
      </select>
      {typeVisited && !data?.entryType ? (
        <span className="errorMessage">
          {data?.entryType ? "" : messageError}
        </span>
      ) : (
        ""
      )}
    </div>
  );
}
